import { faShieldCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    ApplicationRoleCode,
    ILocationResponse,
    IssueStatusType,
    LocationSubscriptionServiceType,
} from '@kcftech/prometheus-client';
import { useRouteLocation } from 'contexts/RouteEntityContext';
import { type PlainIssue } from 'pages/Desk/issues/shared';
import styled from 'styled-components';
import { tokens } from 'styles/tokens';

const IconWrapper = styled.span<{ $size: number }>`
    display: flex;
    align-items: center;
    font-size: ${(props) => props.$size}rem;
`;

export type SentryValidatedIndicatorProps = Readonly<{
    issue: PlainIssue;
    /** Font size in rem units. Defaults to 1.4rem */
    size?: number;
}>;

export function SentryValidatedIndicator({
    issue,
    size = 1.4,
}: SentryValidatedIndicatorProps) {
    const { location } = useRouteLocation();

    if (!isValidatedBySentry(issue, location)) {
        return null;
    }

    return (
        <IconWrapper
            $size={size}
            title="Validated by SENTRYservices"
            aria-label="Validated by SENTRYservices"
        >
            <FontAwesomeIcon icon={faShieldCheck} color={tokens.icon.positive} />
        </IconWrapper>
    );
}

export function isValidatedBySentry(
    issue: PlainIssue,
    location: ILocationResponse,
): boolean {
    const isPublished = issue.IssueStatus.StatusType !== IssueStatusType.Draft;

    const createdBySentry =
        issue.CreatedBy?.ApplicationRole === ApplicationRoleCode.Sentry;

    const publishedBySentry =
        issue.PublishedBy?.ApplicationRole === ApplicationRoleCode.Sentry;

    const hasSentrySubscription =
        location.Settings.SubscriptionService ===
            LocationSubscriptionServiceType.Sentry ||
        location.Settings.SubscriptionService ===
            LocationSubscriptionServiceType.DeskPlus;

    return isPublished && hasSentrySubscription && (createdBySentry || publishedBySentry);
}
